import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { whatsappLink } from "../i18n/translations";
import { TrustBar } from "../components/TrustBar";
import { ReviewCard } from "../components/ReviewCard";
import { MediaGrid } from "../components/MediaGrid";
import { BookingCta } from "../components/BookingCta";

import heroImg from "../assets/img/headstand.jpeg";
import group1Img from "../assets/img/learning_split.jpeg";
import group2Img from "../assets/img/trainer_kid_medal.jpeg";
import group3Img from "../assets/img/rings_split.jpeg";

import medalsImg from "../assets/img/medals_and_balloons.jpeg";
import podiumImg from "../assets/img/podium_new_year.jpeg";
import boyMedal1 from "../assets/img/boy_medal_secondplace.jpeg";
import boyMedal2 from "../assets/img/boy2_medal_secondplace.jpeg";
import boyMedal3 from "../assets/img/boy3_medal_secondplace.jpeg";
import trainerKid2 from "../assets/img/trainer_kid2_medal.jpeg";
import trainerThreeKids from "../assets/img/trainer_threekids_medals.jpeg";
import gramota from "../assets/img/gramota.jpeg";
import boyOnSurf from "../assets/img/boy_on_surf.jpeg";
import girlOnSurf from "../assets/img/girl_on_surf.jpeg";

import reviewImg1 from "../assets/img/zenchenko.jpeg";
import reviewImg2 from "../assets/img/faleeva.jpeg";
import reviewImg3 from "../assets/img/gramota.jpeg";

import reverseHandstand from "../assets/img/reverse_handstand.jpeg";
import zenchenkoChampions from "../assets/img/zenchenko_champions.jpeg";
import saltoTurn from "../assets/img/salto_turn.mp4";
import ropeClimbing from "../assets/img/rope_climbing.mp4";
import floorRotations from "../assets/img/floor_rotations.mp4";
import groupBeginners from "../assets/img/group_beginners.mp4";

export const Ochno = () => {
  const { t } = useLanguage();
  const o = t.ochno;

  const resultsItems = [
    { type: "image", src: medalsImg, alt: "Medals" },
    { type: "image", src: podiumImg, alt: "Podium" },
    { type: "image", src: boyMedal1, alt: "Medal" },
    { type: "image", src: boyMedal2, alt: "Medal" },
    { type: "image", src: boyMedal3, alt: "Medal", position: "center 60%" },
    { type: "image", src: trainerKid2, alt: "Coach with student" },
    { type: "image", src: trainerThreeKids, alt: "Coach with students" },
    { type: "image", src: boyOnSurf, alt: "Boy on surf" },
    { type: "image", src: girlOnSurf, alt: "Girl on surf" },
    { type: "image", src: gramota, alt: "Certificate" },
  ];

  const galleryPreview = [
    { type: "image", src: reverseHandstand, alt: "Reverse handstand" },
    { type: "image", src: zenchenkoChampions, alt: "Champions" },
    { type: "video", src: saltoTurn, alt: "Salto" },
    { type: "video", src: ropeClimbing, alt: "Rope climbing" },
    { type: "video", src: floorRotations, alt: "Floor rotations" },
    { type: "video", src: groupBeginners, alt: "Group beginners" },
  ];

  const reviews = t.reviews;
  const reviewImgs = [reviewImg1, reviewImg2, reviewImg3];

  return (
    <div className="page page-ochno">
      <section
        className="path-hero"
        style={{ backgroundImage: `linear-gradient(180deg, rgba(18,18,18,0.35), rgba(18,18,18,0.85)), url(${heroImg})` }}
      >
        <div className="path-hero-inner">
          <h1>{o.heroTitle}</h1>
          <p>{o.heroSubtitle}</p>
          <a
            className="btn btn-primary"
            href={whatsappLink(o.bookingMessage)}
            target="_blank"
            rel="noreferrer"
          >
            {o.heroCta}
          </a>
        </div>
      </section>

      <TrustBar items={[o.trust1, o.trust2, o.trust3, o.trust4]} />

      <section className="section groups-section">
        <h2>{o.groupsTitle}</h2>
        <div className="groups-grid">
          <div className="group-card">
            <img src={group1Img} alt={o.group1Title} />
            <h3>{o.group1Title}</h3>
            <p>{o.group1Desc}</p>
          </div>
          <div className="group-card">
            <img src={group2Img} alt={o.group2Title} style={{ objectPosition: "center 30%" }} />
            <h3>{o.group2Title}</h3>
            <p>{o.group2Desc}</p>
          </div>
          <div className="group-card">
            <img src={group3Img} alt={o.group3Title} style={{ objectPosition: "center 40%" }} />
            <h3>{o.group3Title}</h3>
            <p>{o.group3Desc}</p>
          </div>
        </div>
      </section>

      <section className="section schedule-section">
        <h2>{o.scheduleTitle}</h2>
        <div className="table-responsive">
          <table className="schedule-table">
            <thead>
              <tr>
                <th>{o.scheduleGroup}</th>
                <th>{o.scheduleTime}</th>
                <th>{o.scheduleDays}</th>
                <th>{o.scheduleLocation}</th>
              </tr>
            </thead>
            <tbody>
              {t.schedule.map((row, i) => (
                <tr key={i}>
                  <td data-label={o.scheduleGroup}>{row.className}</td>
                  <td data-label={o.scheduleTime}>{row.time}</td>
                  <td data-label={o.scheduleDays}>{row.days}</td>
                  <td data-label={o.scheduleLocation}>{row.location}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="section results-section">
        <h2>{o.resultsTitle}</h2>
        <p className="section-subtitle">{o.resultsSubtitle}</p>
        <MediaGrid items={resultsItems} columnsClass="media-grid-4" />
      </section>

      <section className="section reviews-section">
        <h2>{o.reviewsTitle}</h2>
        <div className="reviews-grid">
          {reviews.map((review, i) => (
            <ReviewCard
              key={i}
              title={review.title}
              description={review.description}
              quote={review.quote}
              imgUrl={reviewImgs[i]}
            />
          ))}
        </div>
      </section>

      <section className="section gallery-section">
        <h2>{o.galleryTitle}</h2>
        <p className="section-subtitle">{o.gallerySubtitle}</p>
        <MediaGrid items={galleryPreview} columnsClass="media-grid-4" />
      </section>

      <BookingCta
        title={o.bookingTitle}
        subtitle={o.bookingSubtitle}
        whatsappHref={whatsappLink(o.bookingMessage)}
        whatsappLabel={o.bookingWhatsapp}
      />

      <section className="section corporate-teaser">
        <p>
          {o.corporateTeaser}{" "}
          <Link to="/korporativ" className="text-link">
            {o.corporateLink}
          </Link>
        </p>
      </section>
    </div>
  );
};
